export const listTab = [
  {
    key: "event",
    listId: "PLlyd2e8FEo2ejpWi5vV2PfpVp1tGpchrV",
    label: "Shorts",
    videoIds: ['tmp'],
  },
  {
    key: "updatevideos",
    listId: "PLlyd2e8FEo2e2Q3zt2K-w6b2UA9vGgjVQ",
    label: "Update thành phố",
    videoIds: [
      'tmp'
    ],
  },
  {
    key: "activities",
    listId: "PLlyd2e8FEo2eOQmbWYaGYORK1T06Gvks8",
    label: "Sự kiện thành phố",
    videoIds: [
      'tmp'
    ],
  },
  {
    key: "introduction",
    listId: "PLlyd2e8FEo2dX8RL6Lx7JvicdOhQkbzLE",
    label: "Giới thiệu nghề nghiệp",
    videoIds: ['tmp'],
  },
];
